module.exports = "../images/northern-pike.jpg?v=c97233f";